import { render, staticRenderFns } from "./SectionMap.vue?vue&type=template&id=204a5bac&scoped=true"
import script from "./SectionMap.vue?vue&type=script&lang=js"
export * from "./SectionMap.vue?vue&type=script&lang=js"
import style0 from "./SectionMap.vue?vue&type=style&index=0&id=204a5bac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204a5bac",
  null
  
)

export default component.exports